<div class="page-title">
  <div class="container">
    <h1>{{ title }}</h1>
    <ng-content select=".actions"></ng-content>
  </div>
</div>
